export interface IPaymentType {
    name: string;
    id: number;
}

export enum PaymentTypesEnum {
    CREDIT_CARD = 1,
    PAYPAL = 2,
}

export const PaymentTypes: IPaymentType[] = [
    { name: 'Credit card', id: 1 },
    { name: 'PayPal', id: 2 },
];

export const getPaymentTypeByID = (id: number) => {
    return PaymentTypes.find((p) => p.id === id);
};

export const getPaymentTypeNameById = (id?: number) => {
    return PaymentTypes.find((p) => p.id === id)?.name;
};
